const ArrowDown = ({ className = '' }) => (
  <svg
    width='10'
    height='6'
    viewBox='0 0 10 6'
    fill='none'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 0.999879L5 4.99988L1 0.999878'
      stroke='#442E83'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default ArrowDown
